import { Icon } from "@circle-react/components/shared/Icon";

export const LegacyLoader = () => (
  <div className="flex h-full items-center justify-center">
    <Icon type="loader" />
  </div>
);
